// extracted by mini-css-extract-plugin
export default {"body":"CustomSwitch_body__c-urt","track":"CustomSwitch_track__X5ffH","thumb":"CustomSwitch_thumb__Fm319"};